/**
 * Гидрация блока «Проверь себя» (фаза 2.1) в отрендеренном HTML статьи/урока:
 * клик по варианту → подсветка верно/неверно + объяснение. Ответ никуда не
 * отправляется — это самопроверка, в зачёт не идёт (зачёт — тест урока).
 * Возвращает функцию отписки.
 */
export function hydrateCheckBlocks(root: HTMLElement): () => void {
  const cleanups: Array<() => void> = [];
  for (const block of Array.from(root.querySelectorAll<HTMLElement>('div[data-check]'))) {
    const correct = parseInt(block.getAttribute('data-correct') || '0', 10) || 0;
    const explanation = block.getAttribute('data-explanation') || '';
    const options = Array.from(block.querySelectorAll<HTMLElement>('.fk-check-options > li'));
    const onClick = (e: Event): void => {
      if (block.classList.contains('is-answered')) return;
      const li = (e.target as HTMLElement).closest('li');
      if (!li || !options.includes(li as HTMLElement)) return;
      const idx = options.indexOf(li as HTMLElement);
      block.classList.add('is-answered');
      options[correct]?.classList.add('is-correct');
      if (idx !== correct) li.classList.add('is-wrong');
      const note = document.createElement('div');
      note.className = 'fk-check-explanation';
      const verdict = document.createElement('strong');
      verdict.textContent = idx === correct ? 'Верно! ' : 'Не совсем. ';
      note.appendChild(verdict);
      note.appendChild(document.createTextNode(explanation || (idx === correct ? '' : `Правильный ответ: ${options[correct]?.textContent ?? ''}`)));
      block.appendChild(note);
    };
    block.addEventListener('click', onClick);
    cleanups.push(() => block.removeEventListener('click', onClick));
  }
  return () => cleanups.forEach((fn) => fn());
}
